module.exports = __webpack_public_path__ + "static/saku_238-fe92aebcb2bea003e917b8bdcb7c0818.jpg";